import { AppState } from './../../../../App.state';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { NovoDashboardService } from 'src/app/base/services/novo-dashboard.service';
import { DialogService } from 'src/app/global/services/dialog.service';
import { RenovacaoCredito } from 'src/app/base/domain/dto/renovacao-credito.dto';
import { RenovacaoEvolucaoMensal } from 'src/app/base/domain/dto/renovacao-evolucao-mensal.dto';
import { RenovacaoPorEstado } from 'src/app/base/domain/dto/renovacao-por-estado.dto';
import { RenovacaoRankingFrequencia } from 'src/app/base/domain/dto/renovacao-ranking-frequencia.dto';
import { RenovacaoClientesNaoRenovaram } from 'src/app/base/domain/dto/renovacao-clientes-nao-renovaram.dto';
import { RenovacaoComparativoStatus } from 'src/app/base/domain/dto/renovacao-comparativo-status.dto';

Chart.register(...registerables);

// TODO: falta OnDestroy/unsubscribe — dívida técnica de projeto (mesmo padrão ausente
// em dashboard-estados-clientes e dashboard-parcelas-pagas-vencidas)
@Component({
  selector: 'app-dashboard-renovacao-credito',
  templateUrl: './dashboard-renovacao-credito.component.html',
  styleUrls: ['./dashboard-renovacao-credito.component.css']
})
export class DashboardRenovacaoCreditoComponent implements OnInit {

  @ViewChild('graficoEvolucaoValor', { static: true })
  canvasEvolucaoValor!: ElementRef<HTMLCanvasElement>;

  @ViewChild('graficoEvolucaoOperacoes', { static: true })
  canvasEvolucaoOperacoes!: ElementRef<HTMLCanvasElement>;

  @ViewChild('graficoEvolucaoTicket', { static: true })
  canvasEvolucaoTicket!: ElementRef<HTMLCanvasElement>;

  @ViewChild('graficoEstadoOperacoes', { static: true })
  canvasEstadoOperacoes!: ElementRef<HTMLCanvasElement>;

  @ViewChild('graficoEstadoValor', { static: true })
  canvasEstadoValor!: ElementRef<HTMLCanvasElement>;

  uf = '';
  dataInicio = '';
  dataFim = '';
  valorMin?: number;
  valorMax?: number;
  segmento = '';
  consultor = '';

  segmentosDisponiveis: string[] = [];

  kpis?: RenovacaoCredito;
  evolucaoMensal: RenovacaoEvolucaoMensal[] = [];
  porEstado: RenovacaoPorEstado[] = [];
  rankingClientes: RenovacaoRankingFrequencia[] = [];
  clientesNaoRenovaram: RenovacaoClientesNaoRenovaram[] = [];
  funilAptos?: number;
  funilContatados?: number;
  funilEmNegociacao?: number;
  comparativoStatus: RenovacaoComparativoStatus[] = [];

  erroKpis = false;
  erroEvolucaoMensal = false;
  erroPorEstado = false;
  erroRanking = false;
  erroClientesNaoRenovaram = false;
  erroFunilAptos = false;
  erroFunilContatados = false;
  erroFunilEmNegociacao = false;
  erroComparativoStatus = false;
  erroSegmentos = false;

  // Token de requisição — descarta respostas desatualizadas
  private requestId = 0;

  mostrarRanking = false;
  mostrarClientesNaoRenovaram = false;
  mostrarComparativoStatus = false;
  private rankingCarregado = false;
  private clientesNaoRenovaramCarregado = false;
  private comparativoStatusCarregado = false;

  private chartEvolucaoValor?: Chart;
  private chartEvolucaoOperacoes?: Chart;
  private chartEvolucaoTicket?: Chart;
  private chartEstadoOperacoes?: Chart;
  private chartEstadoValor?: Chart;

  constructor(
    private service: NovoDashboardService,
    private appState: AppState,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadDashboard();
    this.loadSegmentosDisponiveis();
  }

  private loadSegmentosDisponiveis(): void {
    this.erroSegmentos = false;

    this.service.findAllSegmentosClientes(new QueryOptions()).subscribe({
      next: (response) => {
        const segmentos = response.map(item => item.macroSegmento).filter(s => s != null && s !== '');
        this.segmentosDisponiveis = Array.from(new Set(segmentos)).sort();
      },
      error: (error) => {
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/segmentos-atividade (dropdown de segmentos):', error);
        this.erroSegmentos = true;
        this.segmentosDisponiveis = [];
        this.dialogService.feedbackError(
          'Erro ao carregar a lista de segmentos para o filtro. Endpoint pode ainda não estar implementado no back-end.'
        );
      }
    });
  }

  loadDashboard(): void {
    // Token desta chamada
    const requestId = ++this.requestId;

    this.appState.isLoading = true;
    this.erroKpis = false;
    this.erroEvolucaoMensal = false;
    this.erroPorEstado = false;
    this.erroFunilAptos = false;
    this.erroFunilContatados = false;
    this.erroFunilEmNegociacao = false;

    // Drill-downs abertos entram no mesmo contador do spinner
    const recarregarRanking = this.mostrarRanking;
    const recarregarClientesNaoRenovaram = this.mostrarClientesNaoRenovaram;
    const recarregarComparativoStatus = this.mostrarComparativoStatus;

    let pendentes = 6
      + (recarregarRanking ? 1 : 0)
      + (recarregarClientesNaoRenovaram ? 1 : 0)
      + (recarregarComparativoStatus ? 1 : 0);

    // Falhas viram um alerta único, não um popup por endpoint
    const falhas: string[] = [];

    const finalizarCarregamento = (): void => {
      pendentes--;
      if (pendentes === 0 && requestId === this.requestId) {
        this.appState.isLoading = false;
        if (falhas.length > 0) {
          this.dialogService.feedbackError(
            `Não foi possível carregar: ${falhas.join(', ')}. Verifique se os endpoints correspondentes já estão implementados.`
          );
        }
      }
    };

    this.service.findAllRenovacaoCredito(this.buildQueryOptions(true)).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.kpis = response;
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-credito:', error);
        this.erroKpis = true;
        this.kpis = undefined;
        falhas.push('KPIs');
        finalizarCarregamento();
      }
    });

    this.service.findAllRenovacaoEvolucaoMensal(this.buildQueryOptions(true)).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.evolucaoMensal = response;
        this.buildEvolucaoCharts();
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-evolucao-mensal:', error);
        this.erroEvolucaoMensal = true;
        this.evolucaoMensal = [];
        falhas.push('Evolução mensal');
        finalizarCarregamento();
      }
    });

    this.service.findAllRenovacaoPorEstado(this.buildQueryOptions(false)).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.porEstado = response;
        this.buildEstadoCharts();
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-por-estado:', error);
        this.erroPorEstado = true;
        this.porEstado = [];
        falhas.push('Distribuição por estado');
        finalizarCarregamento();
      }
    });

    this.service.findAllRenovacaoAptos(this.buildQueryOptionsAptos()).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.funilAptos = response.reduce((soma, item) => soma + (item.operacoes || 0), 0);
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-aptos:', error);
        this.erroFunilAptos = true;
        this.funilAptos = undefined;
        falhas.push('Aptos para renovação (funil)');
        finalizarCarregamento();
      }
    });

    this.service.findAllRenovacaoContatados(this.buildQueryOptionsAptos()).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.funilContatados = response.reduce((soma, item) => soma + (item.operacoes || 0), 0);
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-contatados:', error);
        this.erroFunilContatados = true;
        this.funilContatados = undefined;
        falhas.push('Contatados (funil)');
        finalizarCarregamento();
      }
    });

    this.service.findAllRenovacaoEmNegociacao(this.buildQueryOptionsAptos()).subscribe({
      next: (response) => {
        if (requestId !== this.requestId) { return; }
        this.funilEmNegociacao = response.reduce((soma, item) => soma + (item.operacoes || 0), 0);
        finalizarCarregamento();
      },
      error: (error) => {
        if (requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-em-negociacao:', error);
        this.erroFunilEmNegociacao = true;
        this.funilEmNegociacao = undefined;
        falhas.push('Em negociação (funil)');
        finalizarCarregamento();
      }
    });

    // Filtro mudou → invalida cache dos drill-downs
    this.rankingCarregado = false;
    if (recarregarRanking) {
      this.loadRanking(requestId, finalizarCarregamento);
    }

    this.clientesNaoRenovaramCarregado = false;
    if (recarregarClientesNaoRenovaram) {
      this.loadClientesNaoRenovaram(requestId, finalizarCarregamento);
    }

    this.comparativoStatusCarregado = false;
    if (recarregarComparativoStatus) {
      this.loadComparativoStatus(requestId, finalizarCarregamento);
    }
  }

  toggleRanking(): void {
    this.mostrarRanking = !this.mostrarRanking;
    if (this.mostrarRanking && !this.rankingCarregado) {
      this.loadRanking();
    }
  }

  // requestId/onComplete: presentes só quando chamado dentro do lote de loadDashboard()
  private loadRanking(requestId?: number, onComplete?: () => void): void {
    const parteDoLote = onComplete !== undefined;
    if (!parteDoLote) {
      this.appState.isLoading = true;
    }
    this.erroRanking = false;

    this.service.findAllRenovacaoRankingFrequencia(this.buildQueryOptions(true)).subscribe({
      next: (response) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        this.rankingClientes = response;
        this.rankingCarregado = true;
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      },
      error: (error) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-ranking-frequencia:', error);
        this.erroRanking = true;
        this.rankingClientes = [];
        this.dialogService.feedbackError(
          'Erro ao carregar o ranking de clientes por frequência de renovação. Endpoint pode ainda não estar implementado no back-end.'
        );
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      }
    });
  }

  toggleClientesNaoRenovaram(): void {
    this.mostrarClientesNaoRenovaram = !this.mostrarClientesNaoRenovaram;
    if (this.mostrarClientesNaoRenovaram && !this.clientesNaoRenovaramCarregado) {
      this.loadClientesNaoRenovaram();
    }
  }

  private loadClientesNaoRenovaram(requestId?: number, onComplete?: () => void): void {
    const parteDoLote = onComplete !== undefined;
    if (!parteDoLote) {
      this.appState.isLoading = true;
    }
    this.erroClientesNaoRenovaram = false;

    this.service.findAllRenovacaoClientesNaoRenovaram(this.buildQueryOptions(true)).subscribe({
      next: (response) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        this.clientesNaoRenovaram = response;
        this.clientesNaoRenovaramCarregado = true;
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      },
      error: (error) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-clientes-nao-renovaram:', error);
        this.erroClientesNaoRenovaram = true;
        this.clientesNaoRenovaram = [];
        this.dialogService.feedbackError(
          'Erro ao carregar os clientes que ainda não renovaram. Endpoint pode ainda não estar implementado no back-end.'
        );
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      }
    });
  }

  toggleComparativoStatus(): void {
    this.mostrarComparativoStatus = !this.mostrarComparativoStatus;
    if (this.mostrarComparativoStatus && !this.comparativoStatusCarregado) {
      this.loadComparativoStatus();
    }
  }

  private loadComparativoStatus(requestId?: number, onComplete?: () => void): void {
    const parteDoLote = onComplete !== undefined;
    if (!parteDoLote) {
      this.appState.isLoading = true;
    }
    this.erroComparativoStatus = false;

    this.service.findAllRenovacaoComparativoStatusFiltrado(this.buildQueryOptions(true)).subscribe({
      next: (response) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        this.comparativoStatus = response;
        this.comparativoStatusCarregado = true;
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      },
      error: (error) => {
        if (requestId !== undefined && requestId !== this.requestId) { return; }
        console.error('[DashboardRenovacaoCredito] Falha em GET /novo-dashboard/renovacao-comparativo-status-filtrado:', error);
        this.erroComparativoStatus = true;
        this.comparativoStatus = [];
        this.dialogService.feedbackError(
          'Erro ao carregar o comparativo Renovado x Reativado. Endpoint pode ainda não estar implementado no back-end.'
        );
        if (parteDoLote) { onComplete(); } else { this.appState.isLoading = false; }
      }
    });
  }

  get funilMaxValor(): number {
    const aptos = this.funilAptos ?? 0;
    const contatados = this.funilContatados ?? 0;
    const emNegociacao = this.funilEmNegociacao ?? 0;
    const renovados = this.kpis?.operacoes ?? 0;
    return Math.max(aptos, contatados, emNegociacao, renovados, 1);
  }

  funilBarWidth(valor: number | undefined): string {
    if (valor === undefined || valor === null) { return '0%'; }
    return `${Math.min(100, (valor / this.funilMaxValor) * 100)}%`;
  }

  // Reaproveita dados já buscados do funil, sem chamada nova
  get taxaConversaoContatoNegociacao(): number | undefined {
    if (this.funilContatados === undefined || this.funilEmNegociacao === undefined) { return undefined; }
    if (this.funilContatados === 0) { return undefined; }
    return Math.round((this.funilEmNegociacao / this.funilContatados) * 100 * 10) / 10;
  }

  private buildQueryOptions(incluirUf: boolean): QueryOptions {
    const params: { [key: string]: string | number } = {};
    if (this.dataInicio) { params.dataInicio = this.dataInicio; }
    if (this.dataFim) { params.dataFim = this.dataFim; }
    if (incluirUf && this.uf) { params.uf = this.uf; }
    if (this.valorMin !== undefined && this.valorMin !== null) { params.valorMin = this.valorMin; }
    if (this.valorMax !== undefined && this.valorMax !== null) { params.valorMax = this.valorMax; }
    if (this.segmento) { params.segmento = this.segmento; }
    if (this.consultor) { params.consultor = this.consultor; }
    return new QueryOptions({ params });
  }

  private buildQueryOptionsAptos(): QueryOptions {
    const params: { [key: string]: string } = {};
    if (this.uf) { params.uf = this.uf; }
    return new QueryOptions({ params });
  }

  private buildEvolucaoCharts(): void {
    if (!this.evolucaoMensal.length) { return; }

    const labels = this.evolucaoMensal.map(item => item.mes);

    if (this.chartEvolucaoValor) { this.chartEvolucaoValor.destroy(); }
    this.chartEvolucaoValor = new Chart(this.canvasEvolucaoValor.nativeElement, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          label: 'Valor Total Renovado (R$)',
          data: this.evolucaoMensal.map(item => item.valorTotal),
          borderColor: '#42a5f5',
          backgroundColor: 'rgba(66,165,245,0.15)',
          fill: true,
          tension: 0.3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true } }
      }
    });

    if (this.chartEvolucaoOperacoes) { this.chartEvolucaoOperacoes.destroy(); }
    this.chartEvolucaoOperacoes = new Chart(this.canvasEvolucaoOperacoes.nativeElement, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: 'Operações',
          data: this.evolucaoMensal.map(item => item.operacoes),
          backgroundColor: '#66bb6a',
          borderRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true } }
      }
    });

    if (this.chartEvolucaoTicket) { this.chartEvolucaoTicket.destroy(); }
    this.chartEvolucaoTicket = new Chart(this.canvasEvolucaoTicket.nativeElement, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          label: 'Ticket Médio (R$)',
          data: this.evolucaoMensal.map(item => item.ticketMedio),
          borderColor: '#ff9800',
          backgroundColor: 'rgba(255,152,0,0.15)',
          fill: true,
          tension: 0.3
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true } }
      }
    });
  }

  private buildEstadoCharts(): void {
    if (!this.porEstado.length) { return; }

    const labels = this.porEstado.map(item => item.uf);

    if (this.chartEstadoOperacoes) { this.chartEstadoOperacoes.destroy(); }
    this.chartEstadoOperacoes = new Chart(this.canvasEstadoOperacoes.nativeElement, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: 'Operações por Estado',
          data: this.porEstado.map(item => item.operacoes),
          backgroundColor: '#42a5f5',
          borderRadius: 8
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true } }
      }
    });

    if (this.chartEstadoValor) { this.chartEstadoValor.destroy(); }
    this.chartEstadoValor = new Chart(this.canvasEstadoValor.nativeElement, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: 'Valor Total Renovado por Estado (R$)',
          data: this.porEstado.map(item => item.valorTotal),
          backgroundColor: '#66bb6a',
          borderRadius: 8
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: { y: { beginAtZero: true } }
      }
    });
  }
}
